import React from "react";
import { notification } from "antd";
import { Toast } from "antd-mobile";
import { isMobile, isTablet, isWeb } from "./layout";
import { AppNotificationType } from "../constants/appNotification";
import type {
  IAppNotification,
  WebNotificationProps,
} from "../types/app-notification";
import {
  BellOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

export const appNotification: IAppNotification = ({
  nTitle,
  nMessage,
  nType,
  ...props
}) => {
  if (isWeb() || isTablet()) {
    return webNotification({
      message: nTitle,
      description: nMessage || "",
      notificationType: nType,
      ...props,
    });
  }
  if (isMobile()) {
    const icon = () => {
      switch (nType) {
        case AppNotificationType.SUCCESS:
          return <CheckCircleOutlined />;
        case AppNotificationType.ERROR:
          return <ExclamationCircleOutlined />;
        case AppNotificationType.LOADING:
          return <ReloadOutlined />;
        default:
          return <BellOutlined />;
      }
    };
    Toast.show({
      content: (
        <div
          data-test-id="bar"
          className={
            nType === AppNotificationType.SUCCESS
              ? "successNotificationToast"
              : "notificationToast"
          }
          style={{ whiteSpace: "pre-line" }}
        >
          {icon()} {nTitle}
        </div>
      ),
      position: "bottom",
    });
  }
};

const webNotification = (props: WebNotificationProps) => {
  switch (props.notificationType) {
    case AppNotificationType.SUCCESS:
      return notification.success(props);
    case AppNotificationType.ERROR:
      return notification.error(props);
    case AppNotificationType.INFO:
      return notification.info(props);
    case AppNotificationType.WARNING:
      return notification.warning(props);
    default:
      return notification.open(props);
  }
};

// ToDo: notification cleaup function if required
